import React from 'react';

import { CardActions } from '@occc-app/design-system';

type FormLayoutProps = {
  actions: React.ReactNode;
  children: React.ReactNode;
};

export const OfferConfigurationWizardFormLayout = ({ actions, children }: FormLayoutProps) => {
  return (
    <>
      <>{children}</>
      <CardActions sx={{ display: 'flex', justifyContent: 'flex-end', px: 0, gap: 1 }}>
        {actions}
      </CardActions>
    </>
  );
};
